import { render, staticRenderFns } from "./Desktops.vue?vue&type=template&id=0326e38e&scoped=true"
import script from "./Desktops.vue?vue&type=script&lang=js"
export * from "./Desktops.vue?vue&type=script&lang=js"
import style0 from "./Desktops.vue?vue&type=style&index=0&id=0326e38e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326e38e",
  null
  
)

export default component.exports